<template>
    <div id="layout">
        <div class="ui fluid container" style="padding: 0 15px;">
            <div class="ui stackable grid">
                <div class="three wide column">
                    <Sidebar v-if="is_initialized">
                    </Sidebar>
                </div>
                <div class="thirteen wide column">
                    <TopMenu>
                    </TopMenu>

                    <div class="ui main segment" style="min-height: 60%;">
                        <Breadcrumb>
                        </Breadcrumb>

                        <router-view v-if="is_initialized">
                        </router-view>
                    </div>

                    <FooterBar>
                    </FooterBar>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '@partials/admin/sidebar.vue'
import TopMenu from '@partials/admin/top_menu.vue'
import FooterBar from '@partials/admin/footer.vue'
import Breadcrumb from '@partials/admin/breadcrumb.vue'

export default {
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
    },
    created() {
        console.log("Layout created")
        this.init()
    },
    mounted() {
        console.log("Layout mounted")
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.$noty.information("Admin"+this.$t('ui.general.initialize_complete'))
                this.is_initialized = true
            })
        },
    },
    components: {
        Sidebar,
        TopMenu,
        FooterBar,
        Breadcrumb,
    },
}
</script>

<style lang="scss">
@import "../../assets/stylesheets/layout.scss";
@import "../../assets/stylesheets/fonts.scss";
</style>
